import { EPOCH } from './constants';

/**
 * Which daily grid it is, in the player's own timezone — a new grid at local
 * midnight, everywhere.
 */
export function dayNumber(now: Date = new Date()): number {
  // Take the local calendar date, then measure it on the UTC timeline: local
  // days are 23 or 25 hours long across a daylight-saving change, which would
  // otherwise repeat or skip a grid number once a year.
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  const epoch = Date.UTC(EPOCH.year, EPOCH.month, EPOCH.day);
  return Math.round((today - epoch) / 86400000) + 1;
}

/** The calendar date a given daily grid belongs to. */
export function dateForDay(day: number): Date {
  return new Date(EPOCH.year, EPOCH.month, EPOCH.day + (day - 1));
}

/** Short, locale-aware label for a grid's date — "Aug 16". */
export function formatDay(day: number): string {
  return dateForDay(day).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

/** Milliseconds until the next grid deals — the coming local midnight. */
export function msUntilNextGrid(now: Date = new Date()): number {
  // Built from calendar fields, so a 23- or 25-hour daylight-saving day still
  // ends exactly when the clock shows midnight.
  const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
  return midnight.getTime() - now.getTime();
}

/** "9h 41m" / "41m" — the wait, rounded up so it never reads "0m". */
export function formatWait(ms: number): string {
  const minutes = Math.max(1, Math.ceil(ms / 60000));
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return h > 0 ? `${h}h ${m}m` : `${m}m`;
}
